"use client";

import { ReactNode } from "react";
import { ICD10Description } from "@/components/common/seo-long-section-description/sections/icd10-description";
import { medsDescription } from "@/components/common/seo-long-section-description/sections/meds-description";
import { calculatorDescription } from "@/components/common/seo-long-section-description/sections/calculator-description";
import { tutorialDescription } from "@/components/common/seo-long-section-description/sections/tutorial-description";
import { videoDescription } from "@/components/common/seo-long-section-description/sections/video-description";
import { videoWebinarDescription } from "@/components/common/seo-long-section-description/sections/video-webinar-description";
import { videoSeriesDescription } from "@/components/common/seo-long-section-description/sections/video-series-description";
import { examsDescription } from "./sections/exams-description";
import { salaryReportDescription } from "@/components/common/seo-long-section-description/sections/salary-report-description";
import { residencyMapDescription } from "@/components/common/seo-long-section-description/sections/residency-map-description";
import { internshipMapDescription } from "./sections/internship-map-description";
import { courseDescription } from "@/components/common/seo-long-section-description/sections/course-description";
import { ebookDescription } from "@/components/common/seo-long-section-description/sections/ebook-description";
import { clinicalCaseDescription } from "@/components/common/seo-long-section-description/sections/clinical-case-description";
import { publicationDescription } from "@/components/common/seo-long-section-description/sections/publication-description";
import { SeoLongSectionDescriptionClient } from "./seo-long-section-description-client";
import { vademecumDescription } from "@/components/common/seo-long-section-description/sections/vademecum-description";
import { cn } from "@/lib/utils";
import { fastQuestionDescription } from "./sections/fast-question-description";

type sectionKeys =
  | "icd10"
  | "tutorial"
  | "fast-question"
  | "meds"
  | "calculator"
  | "video"
  | "video/webinar"
  | "video/series"
  | "video/collections"
  | "exams"
  | "salary-report"
  | "internship-map"
  | "residency-map"
  | "clinical-case"
  | "course"
  | "ebook"
  | "publication"
  | "vademecum";

export const SeoLongSectionDescription = ({
  section,
}: {
  section: sectionKeys;
}) => {
  const map: Record<sectionKeys, { intro: ReactNode; content: ReactNode }> = {
    icd10: ICD10Description,
    meds: medsDescription,
    calculator: calculatorDescription,
    tutorial: tutorialDescription,
    "fast-question": fastQuestionDescription,
    video: videoDescription,
    "video/webinar": videoWebinarDescription,
    "video/series": videoSeriesDescription,
    "video/collections": videoSeriesDescription,
    exams: examsDescription,
    "salary-report": salaryReportDescription,
    "residency-map": residencyMapDescription,
    "internship-map": internshipMapDescription,
    "clinical-case": clinicalCaseDescription,
    course: courseDescription,
    ebook: ebookDescription,
    publication: publicationDescription,
    vademecum: vademecumDescription,
  };

  return (
    <div
      className={cn(
        "text-zinc-500",
        "[&_p]:my-4 [&_p]:text-sm",
        "[&_li]:my-4 [&_li]:text-sm [&_ol]:my-4 [&_ol]:list-decimal [&_ol]:pl-5 [&_ol]:md:pl-8 [&_ul]:my-4 [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:md:pl-8",
        "[&_h3]:mt-8 [&_h3]:mb-4 [&_h3]:font-semibold [&_h3]:text-zinc-700",
      )}
    >
      <SeoLongSectionDescriptionClient
        intro={map[section].intro}
        content={map[section].content}
      />
    </div>
  );
};
